module.exports = __webpack_public_path__ + "img/coxa-media.3be9cb8b.png";